<script setup lang="ts">
import { QCheckbox, QItem } from 'quasar'
import { computed } from 'vue'
import { Color } from '@previo/codebooks'
import PTextFormBody from '../typography/form/PTextFormBody.vue'
import { PMaxLines } from '../typography/types'

type Props = {
  label?: null | string
  value: null | number | string | boolean
  leftLabel?: boolean
  disable?: boolean
  errorMessage?: null | string
  cy: string
}

const model = defineModel<string[] | number[] | boolean[]>()

const props = withDefaults(defineProps<Props>(), {
  leftLabel: false,
  disable: false,
})

const color = computed<Color.NEGATIVE | Color.PRIMARY | Color.GREY_400>(() => {
  if (props.disable) {
    return Color.GREY_400
  }

  return props.errorMessage ? Color.NEGATIVE : Color.PRIMARY
})
</script>

<template>
  <div class="ds-p-checkbox-group">
    <q-item tag="label" manual-focus class="p-items-start">
      <q-checkbox
        v-model="model"
        :val="value"
        dense
        size="48px"
        :left-label="leftLabel"
        :disable="disable"
        :color="color"
        :keep-color="!!errorMessage"
        checked-icon="fa-light fa-square-check"
        unchecked-icon="fa-light fa-square"
        indeterminate-icon="fa-light fa-square-minus"
        :data-cy="cy"
      >
        <template #default>
          <div class="p-flex p-no-wrap">
            <p-text-form-body :text="label" :max-lines="PMaxLines.ONE" />
          </div>
        </template>
      </q-checkbox>
    </q-item>
  </div>
</template>
